import React from 'react';
import classNames from 'classnames';
import PopNotification from 'providers/PopNotifications/components/PopNotification';
import UndoButton from 'components/UndoButton';

import './PopNotificationWithUndo.styles.scss';

type PopNotificationWithUndoProps = {
  className?: string;
  isUndoAvailable: boolean;
  disabled?: boolean;
  onUndo: () => void;
};

const PopNotificationWithUndo: React.FC<PopNotificationWithUndoProps> = (
  props,
) => {
  const { children, className, isUndoAvailable, disabled, onUndo } = props;

  const classes = classNames(
    'pop-notification-with-undo',
    'pop-notif-plat',
    className,
  );

  if (!isUndoAvailable) return null;

  return (
    <PopNotification
      className={classes}
      side="top"
      type="Success"
      closable={false}
    >
      {children}
      <UndoButton variant="outline" disabled={disabled} onUndo={onUndo} />
    </PopNotification>
  );
};

export default PopNotificationWithUndo;
